import { render, staticRenderFns } from "./manage-role.vue?vue&type=template&id=084dd00f"
import script from "./manage-role.vue?vue&type=script&lang=js"
export * from "./manage-role.vue?vue&type=script&lang=js"
import style0 from "./manage-role.vue?vue&type=style&index=0&id=084dd00f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports